



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { RegisterFeature } from '../../common/types';

@Component
export default class RegisterCard extends Vue {
  @Prop() features!: Array<RegisterFeature>;

  @Prop({ default: false }) loginForm!: Array<RegisterFeature>;

  @Prop() loginFeature!: Array<RegisterFeature>;
}
